import { render, staticRenderFns } from "./MultipleClientSelect.vue?vue&type=template&id=42491b27"
import script from "./MultipleClientSelect.vue?vue&type=script&lang=js"
export * from "./MultipleClientSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleClientSelect.vue?vue&type=style&index=0&id=42491b27&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42491b27')) {
      api.createRecord('42491b27', component.options)
    } else {
      api.reload('42491b27', component.options)
    }
    module.hot.accept("./MultipleClientSelect.vue?vue&type=template&id=42491b27", function () {
      api.rerender('42491b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/MultipleClientSelect.vue"
export default component.exports